// @flow

import { put, takeLatest } from 'redux-saga/effects'
import { fetchFeaturedPolls } from '../stores/polls/featured'
import { clearPollsStore } from '../stores/pollsStore'
import { clearFeaturedPolls } from '../stores/polls/featured'
import { SELECT_CUSTOMER_VIEW } from '../stores/ui/selectedCustomer'
import { clearCursors } from '../stores/cursoredUrlsStore'
import { fetchPollsIntoStore } from './fetchPolls'
import {
  clearAutomatedPolls,
  fetchAutomatedPolls,
} from '../stores/polls/automated'

export function* refreshOnCustomerSelection(): * {
  yield takeLatest(SELECT_CUSTOMER_VIEW, function* handleFetchFeaturedPolls() {
    yield put(clearCursors())
    yield put(clearPollsStore())
    yield put(clearFeaturedPolls())
    yield put(clearAutomatedPolls())
    yield put(fetchAutomatedPolls())
    yield put(fetchFeaturedPolls())
    yield put(fetchPollsIntoStore())
  })
}



// WEBPACK FOOTER //
// ./src/sagas/refreshOnCustomerSelection.js